import {
  ADD_TOURNAMENT_UNABLE_TO_MATCH_MAP,
  FOREGROUND_UNITY_LAUNCH,
  MT_REMOVE_TOURNAMENT_FROM_STARTED_LIST,
  MT_TOURNAMENT_STARTING,
  ON_ROOM_READY,
  REMOVE_SNL_INFO,
  SNL_UNITY_INVOKED,
  STORE_SNL_TOURNAMENT_INFO,
  TOURNAMENT_STARTING,
  SHOW_DGP_GAMEPLAY_EXP
} from '../reduxConstants'
import _filter from 'lodash/filter'

const initialState = {
  tournamentStarting: false,
  mttTournamentStarting: false,
  startedTournamentsIdMap: [],
  unableToMatchTournamentsIdMap: [],
  snlUnity: {
    unityInvoked: false,
    unityRoom: false,
    tournamentJoined: {},
    launchUnityWhenAppInForeground: false
  },
  showDirectGameplayExp: false
}

export default function gameplayReducer(state = initialState, action: { type: any; payload: { tournamentId?: never; tournamentStarting?: any; mttTournamentStarting?: any }; tournamentId: any; data: { name: any; data: any }; showDirectGameplayExp: any }) {
  switch (action.type) {
    case TOURNAMENT_STARTING: {
      const { tournamentId, tournamentStarting } = action?.payload
      let startedTournamentsIdMap = [...state.startedTournamentsIdMap]
      if (tournamentId) {
        startedTournamentsIdMap.push(tournamentId)
      }
      return { ...state, tournamentStarting, startedTournamentsIdMap }
    }

    case MT_TOURNAMENT_STARTING: {
      const { tournamentId, mttTournamentStarting } = action.payload
      let startedTournamentsIdMap = [...state.startedTournamentsIdMap]
      if (tournamentId) {
        startedTournamentsIdMap.push(tournamentId)
      }
      return { ...state, mttTournamentStarting, startedTournamentsIdMap }
    }

    case MT_REMOVE_TOURNAMENT_FROM_STARTED_LIST: {
      return { ...state, startedTournamentsMap: _filter(state.startedTournamentsIdMap, tId => tId !== action.tournamentId) }
    }
    case ADD_TOURNAMENT_UNABLE_TO_MATCH_MAP:
      return { ...state, unableToMatchTournamentsIdMap: [...state.unableToMatchTournamentsIdMap, action.tournamentId] }
    case ON_ROOM_READY:
      return {
        ...state,
        snlUnity: {
          ...state.snlUnity,
          unityRoom: action.data
        }
      }
    case SNL_UNITY_INVOKED:
      return {
        ...state,
        snlUnity: { ...state.snlUnity, unityInvoked: action.data }
      }
    
    case SHOW_DGP_GAMEPLAY_EXP:
      return {
        ...state,
        showDirectGameplayExp: action.showDirectGameplayExp
      }
    
    case REMOVE_SNL_INFO:
      return {
        ...state,
        snlUnity: initialState.snlUnity
      }
    case STORE_SNL_TOURNAMENT_INFO:
      var { name, data } = action.data
      var snlUnityData = state.snlUnity
      return {
        ...state,
        snlUnity: {
          ...snlUnityData,
          tournamentJoined: {
            ...snlUnityData.tournamentJoined,
            [name]: data
          }
        }
      }
    case FOREGROUND_UNITY_LAUNCH:
      return {
        ...state,
        snlUnity: {
          ...state.snlUnity,
          launchUnityWhenAppInForeground: action.data
        }
      }
    default:
      return state
  }
}
